import React, { Component } from 'react';
import './StatModelMoreInfo.css';
import Table from 'react-bootstrap/Table';

class InnerReferences extends Component {
    render () {
        return (
          <div>
            <div>
              <Table className='border'>
                <thead className='smoke30-bg'>
                  <tr>
                    <th>Index</th>
                    <th>Document Title</th>
                  </tr>
                </thead>
                <tbody>
                <tr>
                    <td>[1]</td>
                    <td>Kumar, R. S., Mawman, D., Sankaran, D., Melling, C., O'Driscoll, M., Freeman, S. M., & Lloyd, S. K. (2016). Cochlear implantation in early deafened, late implanted adults: Do they benefit?. Cochlear implants international, 17(sup1), 22-25.</td>
                  </tr>                                
                  <tr>
                    <td>[2]</td>
                    <td>Castiglione, A., Benatti, A., Girasoli, L., Caserta, E., Montino, S., Pagliaro, M., ... & Martini, A. (2015). Cochlear implantation outcomes in older adults. Hearing, Balance and Communication, 13(2), 86-88.</td>
                  </tr>                                
                  <tr>
                    <td>[3]</td>
                    <td>Lenarz, M., Sönmez, H., Joseph, G., Büchner, A., & Lenarz, T. (2012). Long-term performance of cochlear implants in postlingually deafened adults. Otolaryngology--Head and Neck Surgery, 147(1), 112-118.</td>
                  </tr>                                
                  <tr>
                    <td>[4]</td>
                    <td>Severity of Hearing Loss Categories for Binaural Outcomes Prediction Models</td>
                  </tr>                                
                  <tr>
                    <td>[5]</td>
                    <td>Prototype Binaural English Word Score Outcomes Model</td>
                  </tr>                                
                  <tr>
                    <td>[6]</td>
                    <td>SSQ Data Analysis for Binaural Referral Support Tool</td>
                  </tr>                                
                  <tr>
                    <td>[7]</td>
                    <td>CAM5717 Retrospective Study</td>
                  </tr>                                
                  <tr>
                    <td>[8]</td>
                    <td>CLTD5685 – CIP – Clinical Evaluation of the Cochlear Nucleus CI532 Cochlear Implant in Adults</td>
                  </tr>                                
                  <tr>
                    <td>[9]</td>
                    <td>Clinical Investigation Title: Prediction of Outcomes in Adult Cochlear Implant Recipients</td>
                  </tr>                                
                  <tr>
                    <td>[10]</td>
                    <td>CEL5277 IROS CLINICAL INVESTIGATION REPORT</td>
                  </tr>                                               
                  <tr>
                    <td>[11]</td>
                    <td>Holder, J. T., Dwyer, N. C., & Gifford, R. H. (2020). Duration of processor use per day is significantly correlated with speech recognition abilities in adults with cochlear implants. Otology & neurotology: official publication of the American Otological Society, American Neurotology Society [and] European Academy of Otology and Neurotology, 41(2), e227.</td>
                  </tr>                                
                  <tr>
                    <td>[12]</td>
                    <td>Holder, J. T., & Gifford, R. H. (2021). Effect of increased daily cochlear implant use on auditory perception in adults. Journal of Speech, Language, and Hearing Research, 64(10), 4044-4055.</td>
                  </tr>                                
                  <tr>
                    <td>[13]</td>
                    <td>Busch, T., Vanpoucke, F., & van Wieringen, A. (2017). Auditory environment across the life span of cochlear implant users: Insights from data logging. Journal of Speech, Language, and Hearing Research, 60(5), 1362-1377.</td>
                  </tr>                                
                  <tr>
                    <td>[14]</td>
                    <td>Bento, R. F., Brito Neto, R., Castilho, A. M., Gómez, V. G., Giorgi, S. B., & Guedes, M. C. (2004). Auditory results with multichannel cochlear implant in patients submitted to cochlear implant surgery at Medical School, Hospital das Clínicas, University of Sao Paulo. Braz J Otorhinolaryngol, 70, 632-7.</td>
                  </tr>                                
                  <tr>
                    <td>[15]</td>
                    <td>Zhao, F., Stephens, S. D. G., Sim, S. W., & Meredith, R. (1997). The use of qualitative questionnaires in patients having and being considered for cochlear implants. Clinical Otolaryngology & Allied Sciences, 22(3), 254-259.</td>
                  </tr>                                
                  <tr>
                    <td>[16]</td>
                    <td>Wick, C. C., Kallogjeri, D., McJunkin, J. L., Durakovic, N., Holden, L. K., Herzog, J. A., ... & CI532 Study Group. (2020). Hearing and quality-of-life outcomes after cochlear implantation in adult hearing aid users 65 years or older: a secondary analysis of a nonrandomized clinical trial. JAMA Otolaryngology–Head & Neck Surgery, 146(10), 925-932.</td>
                  </tr>                                
                  <tr>
                    <td>[17]</td>
                    <td>Porps, S. L., Bennett, D. M., Gilden, J., Ravelo, K., Buck, B., Reinhart, P., & Hong, R. S. (2023). Effects of an evidence-based model for cochlear implant aftercare delivery on clinical efficiency and patient outcomes. Cochlear Implants International, 1-10.</td>
                  </tr>                                
                  <tr>
                    <td>[18]</td>
                    <td>Reed, C. M., & Delhorne, L. A. (2005). Reception of environmental sounds through cochlear implants. Ear and hearing, 26(1), 48-61.</td>
                  </tr>                                
                  <tr>
                    <td>[19]</td>
                    <td>Di Nardo, W., Anzivino, R., Giannantonio, S., Schinaia, L., & Paludetti, G. (2014). The effects of cochlear implantation on quality of life in the elderly. European Archives of Oto-Rhino-Laryngology, 271, 65-73.</td>
                  </tr>    
                  <tr>
                    <td>[20]</td>
                    <td>Gatehouse, S., & Noble, W. (2004). The speech, spatial and qualities of hearing scale (SSQ). International journal of audiology, 43(2), 85-99.</td>
                  </tr>                                                  
                </tbody>
              </Table>
            </div>          
          </div> 
          );
    }
}

export default InnerReferences;